import u from "./index808.js";
function f(e, r, t) {
  var n = e == null ? void 0 : u(e, r);
  return n === void 0 ? t : n;
}
export {
  f as default
};
